// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__Ltghh","section":"Layout_section__1sJh5"};